// TotalAndAvgHoursDialog.js
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';


// Helper function to format the date as 'Month Day, Year'
const formatDate = (date) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(date).toLocaleDateString(undefined, options);
};

const TotalAndAvgHoursDialog = ({ open, onClose, user }) => {
  if (!user) return null; // If no user is passed, don't render anything

  const currentDate = formatDate(new Date()); // Get and format the current date

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Total & Average Hours for {user.name}</DialogTitle>
      <DialogContent>
        <Box sx={{ padding: 2 }}>
          <Typography variant="h6" gutterBottom>
            <AccountCircleIcon fontSize="small" /> Employee Details
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Typography variant="body1">
            <strong>Employee ID:</strong> {user.id}
          </Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            <strong>Joining Date:</strong> {formatDate(user.joiningDate)} {/* Format joining date */}
          </Typography>
        </Box>
        <Box sx={{ padding: 2 }}>
          <Typography variant="h6" gutterBottom>
            <AccessTimeIcon fontSize="small" /> Hours Information
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Typography variant="body1" sx={{ mt: 1 }}>
            <strong>Current Date:</strong> {currentDate} {/* Display current date */}
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            <strong>Total Hours:</strong> {user.totalHours}
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            <strong>Daily Average Hours:</strong> {user.avgHours} /day
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ color: 'red' }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TotalAndAvgHoursDialog;
